import { FinancingCtaFragmentFragment } from '../../__generated__/graphql';
import ButtonLink from '../../components/Button/ButtonLink';
import CheckMark from '../../components/icons/CheckMark';
import { Heading2, Paragraph } from '../../components/Text';
import Section from '../../layout/Section';
import { ContentBlock } from '../types';

import style from './financing-cta.module.css';

const FinancingCta: ContentBlock<FinancingCtaFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.financingCta;

  if (!contentBlockProps) {
    return null;
  }

  return (
    <Section
      backgroundColor="black"
      id={contentBlockProps.sectionId}
    >
      <div className={style.card}>
        <Heading2 className={style.cardTitle}>
          {contentBlockProps.title}
        </Heading2>

        <ButtonLink
          buttonColor="orange"
          className={style.ctaButton}
          id={contentBlockProps.buttonId ?? undefined}
          linkFragment={contentBlockProps.button}
        />

        <ul className={style.keyPointsList}>
          {contentBlockProps.keyPoints?.map(keyPoint => {
            if (keyPoint) {
              return (
                <li
                  className={style.keyPoint}
                  key={keyPoint.value}
                >
                  <span className={style.iconWrapper}>
                    <CheckMark />
                  </span>
                  <Paragraph fontSize={18}>
                    {(keyPoint.field ?? '').trim() && (
                      <strong>
                        {keyPoint.field}
                        :
                        {' '}
                      </strong>
                    )}
                    {keyPoint.value}
                  </Paragraph>
                </li>
              );
            }
          })}
        </ul>
      </div>
    </Section>
  );
};

export default FinancingCta;
